// extracted by mini-css-extract-plugin
export default {"notResidentBlock":"aTh52c"};